import {Component, OnInit} from '@angular/core';
import {Task} from 'app/entities/Task';
import {TaskService} from '../../services/task.service';
import {Responsible} from '../../entities/SalesPerson';
import {TaskFilterModel} from '../../entities/filter-models/TaskFilterModel';
import {SalesPersonService} from '../../services/sales-person.service';
import {JobService} from '../../services/job.service';
import {Job} from '../../entities/Job';
import {CommunicationLogService} from '../../services/communication-log.service';
import {CommunicationLog} from '../../entities/CommunicationLog';
import {LoginService} from '../../services/login.service';
import {AppFile} from '../../entities/AppFile';
import {FileService} from '../../services/file.service';
import {CreateTaskWithFiles} from '../../entities/CreateTaskWithFiles';

@Component({
  selector: 'app-task-administration',
  templateUrl: './task-administration.component.html',
  styleUrls: ['./task-administration.component.css']
})
export class TaskAdministrationComponent implements OnInit {

  public tasks: Task[] = [];
  public tasksFilter: Task[] = [];
  public responsible: string;
  public communicationLogs: CommunicationLog[] = [];
  public chosenTask: Task;
  public filesToUpload: AppFile[] = [];
  public loading = false;
  public filesToDownload: AppFile[] = [];

  public salesPersons: Responsible[] = [];
  public jobs: Job[] = [];
  public doneLoading: boolean;

  private taskFilterModel: TaskFilterModel = new TaskFilterModel();

  constructor(private taskService: TaskService,
              private salesPersonService: SalesPersonService,
              private jobService: JobService,
              private communicationLogService: CommunicationLogService,
              private loginService: LoginService,
              private fileService: FileService) {
  }

  ngOnInit() {
    this.taskService.getTasks().subscribe(tasks => {
      this.tasksFilter = tasks;
      this.tasks = tasks;
    });

    this.jobService.GetJobs().subscribe(jobNo => {
      this.jobs = jobNo;
    });

    this.salesPersonService.getAllSalesPersonsAsSalesPerson().subscribe(salesPersons => {
      this.salesPersons = salesPersons;
    });
  }

  updateTask(taskToUpdate: Task) {
    this.taskService.putTaskInfo(taskToUpdate).subscribe(data => {
      this.taskService.getTasks().subscribe(tasks => {
        this.tasksFilter = tasks;
        this.filterTask();
      });
    });
  }

  createTask(taskToCreate: CreateTaskWithFiles) {
    this.taskService.postTaskInfo(taskToCreate.TaskToCreate).subscribe(data => {

      for (let file of taskToCreate.Files) {
        let task_guid = data._body;
        let rightTaskGuid = task_guid.replace(new RegExp('"', 'g'), '');
        file.Key = rightTaskGuid;
      }
      if(taskToCreate.Files != null && taskToCreate.Files.length > 0) {
        this.fileService.uploadFiles(taskToCreate.Files, this.chosenTask.Company_Reference).subscribe(t => {
          this.updateView(taskToCreate);
        });
      }
      else {
        this.updateView(taskToCreate);
      }
    });
  }

  updateView(taskToCreate: CreateTaskWithFiles){
    this.taskService.getTasks().subscribe(tasks => {
      this.tasksFilter = tasks;
      this.filterTask();
    });
    if (taskToCreate.TaskToCreate.Create_Job == true) {
      this.jobService.GetJobs().subscribe(jobNo => {
        this.jobs = jobNo;
      });
    }
  }

  showTaskDetails(task: Task) {
    this.taskService.getTask(task.Task_GUID).subscribe(task => {
      this.chosenTask = task;
      this.getFiles(task);
      this.fetchCommunicationLogs(this.chosenTask.No);
    });

    this.chosenTask = Object.assign({}, task);
  }

  showCreateTask() {
    this.jobService.GetJobs().subscribe(jobs => this.jobs = jobs);
  }

  setfilterTask(filterInput: TaskFilterModel) {
    this.taskFilterModel = filterInput;
    this.filterTask();
  }

  filterTask() {
    let taskToFilter = this.tasksFilter;

    if (this.taskFilterModel.ResponsibleInput !== '') {
      taskToFilter = taskToFilter.filter(task => task.Responsible.toUpperCase() == this.taskFilterModel.ResponsibleInput.toUpperCase());
    }

    if (this.taskFilterModel.StatusInput !== '') {
      taskToFilter = taskToFilter.filter(task => task.Status.toUpperCase() == this.taskFilterModel.StatusInput.toUpperCase());
    }

    if (this.taskFilterModel.JobNoInput !== '') {
      taskToFilter = taskToFilter.filter(task => task.JobNo.toUpperCase() == this.taskFilterModel.JobNoInput.toUpperCase());
    }

    if (this.taskFilterModel.ToBeDoneByInput !== '') {
      taskToFilter = taskToFilter.filter(task => task.To_Be_Done_By.toUpperCase() == this.taskFilterModel.ToBeDoneByInput.toUpperCase());
    }
    this.tasks = taskToFilter;
    this.deadlineFilter();
  }

  fetchTasks(_tasks) {
    this.taskService.getTasks().subscribe(tasks => {
      this.tasksFilter = tasks;
      this.filterTask();
    });
  }

  createCommunicationLog(note: string) {
    let text: string = '';
    let communicationLog: CommunicationLog = {
      Task_GUID: this.chosenTask.Task_GUID,
      Creation_Date: new Date(),
      Note: note
    };
    communicationLog.Created_By_Ref = this.loginService.getLoggedInUserID();
    this.communicationLogService.CreateCommunicationLog(communicationLog).subscribe(response => {
      text = response;
      this.fetchCommunicationLogs(this.chosenTask.No);
    });

  }

  fetchCommunicationLogs(taskNo: string) {
    this.communicationLogService.GetCommunicationLogs(taskNo).subscribe(response => {
      this.communicationLogs = response;
      this.communicationLogs.reverse();
    });
  }

  uploadFiles(files: AppFile[]) {
    if (files.length > 0) {
      this.loading = true;

      this.fileService.uploadFiles(files, this.chosenTask.Company_Reference).subscribe(success => {
        this.loading = false;
        const length = files.length;
        if (success.length === 0) {
          console.log('length - success.length' + ' fil/filer eksisterer allerede.');
          //this.snackBar.open(length - success.length + ' fil/filer eksisterer allerede. ', 'OK', {duration: 3000});
        }
        for (let j = 0; j < length; j++) {
          this.removeFile(this.filesToUpload[0]);
        }
        this.getFiles(this.chosenTask);
        this.doneLoading = true;
      });
      this.doneLoading = false;
    } else {
      const message = 'Vælg filer der skal uploades før du trykker upload'
      //this.snackBar.open(message, 'OK', {duration: 3000});
    }

  }

  removeFile(file: AppFile) {
    const index = this.filesToUpload.indexOf(file);
    if (index > -1) {
      this.filesToUpload.splice(index, 1);
    }
  }

  getFiles(task: Task) {
    if (task.Task_GUID != null) {
      this.fileService.getFilesByKey(task.Task_GUID, 'App Task', this.chosenTask.Company_Reference).subscribe(files => this.filesToDownload = files);
    }
  }

  downloadFile(file) {
    this.fileService.downloadFile(file.No).subscribe(blob => {
      const fileUrl = URL.createObjectURL(blob);
      let nav = window.navigator as any;
      // for IE 10+
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, file.FileName);
      } else {
        const element = document.createElement('a');
        element.href = fileUrl;
        element.setAttribute('download', file.FileName);
        element.setAttribute('target', '_blank');

        element.dispatchEvent(new MouseEvent('click'));
        URL.revokeObjectURL(fileUrl);
      }
    });
  }

  deadlineFilter() {
    let tempArray = [];
    let todaysDate = new Date();
    for (let task of this.tasks) {
      let taskDeadline = new Date(task.Deadline);
      if (taskDeadline > todaysDate) {
        tempArray.push(task);
      }
    }

    this.tasks.forEach(t => {
      let taskDeadline = new Date(t.Deadline);
      if (taskDeadline.getFullYear() <= todaysDate.getFullYear()) {
        if (taskDeadline.getMonth() <= todaysDate.getMonth()) {
          if (taskDeadline.getDate() <= todaysDate.getDate()) {
            tempArray.push(t);
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/task-administration/task-administration.component.ts